// extracted by mini-css-extract-plugin
export default {"contenedor":"HistorialModal_contenedor__Fj8UF","barra":"HistorialModal_barra__GWxWc","conteo":"HistorialModal_conteo__Xle0+","tabla":"HistorialModal_tabla__actaJ"};